import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers/reducers';
import { initParams } from './reducers/params';
import { initData } from './reducers/data';
import App from './components/App/App';
import i18n from './i18n';
import './index.css';

// the id of the div to render too
let appId = 'fundlisting';

// optionally set param from window.fundListingsParams
if (window.fundListingsParams) {
  const params = window.fundListingsParams;
  if (params.divisionParam) initParams.division = params.divisionParam;
  if (params.division) initParams.division = Number(params.division).toString();
  if (params.wtRegion) initParams.wtRegion = params.wtRegion;
  if (params.isoCode) initParams.isoCode = params.isoCode;
  if (params.isLeveraged) initParams.isLeveraged = Number(params.isLeveraged).toString();
  if (params.isFP) initParams.isFP = Number(params.isFP).toString();
  if (params.esg) initParams.esg = params.esg;
}

// are we in EU?
if (initParams.division === '2') {
  initParams.isEU = true;
}

// set iso code and update language to use
if (!initParams.isoCode.includes('-')) {
  initParams.isoCode = `${initParams.isoCode}-${initParams.wtRegion}`;
}
i18n.changeLanguage(initParams.isoCode);

// render
ReactDOM.render(
  <Provider
    store={createStore(
      reducers,
      { params: initParams, data: initData },
      applyMiddleware(thunk),
    )}
  >
    <App />
  </Provider>,
  document.getElementById(appId),
);



// WEBPACK FOOTER //
// ./src/index.js